import React, { useState } from "react";
import { Play } from "lucide-react";

function youtubeEmbed(url) {
  const m = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]+)/);
  return m ? `https://www.youtube.com/embed/${m[1]}` : null;
}

export default function TutorialVideo({ tutorial, compact = false }) {
  const [playing, setPlaying] = useState(false);
  const yt = tutorial.video_url ? youtubeEmbed(tutorial.video_url) : null;
  const isMp4 = tutorial.video_url && /\.(mp4|webm|ogg)(\?|$)/i.test(tutorial.video_url);
  const hasVideo = !!tutorial.video_url;

  return (
    <div className={`kb-card overflow-hidden ${compact ? "" : "flex flex-col"}`} data-testid={`tutorial-${tutorial.key}`}>
      <div className="relative aspect-video bg-slate-100 bg-cover bg-center group cursor-pointer"
           style={{ backgroundImage: `url(${tutorial.thumbnail_url || ''})` }}
           onClick={() => hasVideo && setPlaying(true)}>
        {!playing && (
          <div className="absolute inset-0 flex items-center justify-center bg-black/30 group-hover:bg-black/50 transition-colors">
            <div className={`w-14 h-14 rounded-full flex items-center justify-center ${hasVideo ? "bg-white text-kb-primary" : "bg-white/40 text-white"}`}>
              <Play className="w-5 h-5 ml-0.5" fill="currentColor" />
            </div>
          </div>
        )}
        {!hasVideo && (
          <div className="absolute bottom-2 right-2 kb-mono text-[10px] uppercase tracking-wider text-white bg-black/60 px-2 py-1 rounded-sm">
            VIDEO COMING SOON
          </div>
        )}
        {playing && yt && (
          <iframe className="absolute inset-0 w-full h-full" src={yt + "?autoplay=1"} title={tutorial.title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
        )}
        {playing && isMp4 && (
          <video controls autoPlay className="absolute inset-0 w-full h-full bg-black">
            <source src={tutorial.video_url} />
          </video>
        )}
      </div>
      <div className="p-4">
        <div className="kb-mono text-[10px] uppercase tracking-wider text-kb-primary">{tutorial.category}</div>
        <div className="font-serif text-base text-kb-ink mt-1 leading-tight">{tutorial.title}</div>
        {!compact && tutorial.description && (
          <div className="text-xs text-kb-ink-muted mt-2 line-clamp-2">{tutorial.description}</div>
        )}
      </div>
    </div>
  );
}
